export { default } from './useGetWipStatusBannerComponent';
